<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-date-picker
          size="medium"
          disabled
          :type="type"
          :placeholder="placeholder"
      ></el-date-picker>
    </div>
    <div v-else>
      <el-date-picker
          @change="setlongHour"
          v-model="_value"
          :value-format="format"
          size="medium"
          clearable
          :type="type"
          :placeholder="placeholder"
          :disabled="r"
      ></el-date-picker>
    </div>
  </div>
</template>

<script>
import componentMinxins from "../ComponentMinxins";
import {commuter} from "@/api/design";
import moment from "moment";

export default {
  mixins: [componentMinxins],
  name: "DateTime",
  components: {},
  props: {
    forms: {
      type: Array,
      default: () => {
        return []
      },
    },
    labelName: {
      default: null,
    },
    value: {
      default: null,
    },
    format: {
      type: String,
      default: "yyyy-MM-dd HH:mm",
    },
    placeholder: {
      type: String,
      default: "请选择日期时间",
    },
    config1: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    type() {
      switch (this.format) {
        case "yyyy":
          return "year";
        case "yyyy-MM":
          return "month";
        case "yyyy-MM-dd":
          return "date";
        case "yyyy-MM-dd HH:mm":
          return "datetime";
        default:
          return "datetime";
      }
    },
  },
  data() {
    return {
      typeName: this.$route.params.labelName,
      r: false
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.config1) {
        if (
            this.config1.flag == 2 ||
            this.config1.flag == 3 ||
            this.config1.flag == 4
        ) {
          console.log("仅可读仅可读");
          this.r = true;
        } else {
          var perm = this.config1.perm;
          if (perm == "R") {
            this.r = true;
          }
        }
      }
    }, 500);
  },
  methods: {
    setlongHour() {
      let that = this;
      that.forms.forEach(item => {
        let beginTimeDate = '';
        let endTimeDate = '';
        if (item.title == '时长（小时）') {
          that.forms.forEach(item => {
            if (item.title == '开始时间') {
              beginTimeDate = that.$store.state.formValue[item.id];
            } else if (item.title == '结束时间') {
              endTimeDate = that.$store.state.formValue[item.id];
            }
          })
          console.log(beginTimeDate)
          let params = {
            userId: that.$route.params.userId==undefined?that.$route.query.userId:that.$route.params.userId,
            platformId: that.$route.params.platformId==undefined?that.$route.query.platformId:that.$route.params.platformId,
            deptId: that.$route.params.deptId==undefined?that.$route.query.deptId:that.$route.params.deptId
          }
          commuter(params)
              .then((res) => {
                if (res.code == 200) {
                  if (res.data.length > 0) {
                    let beginTime = res.data[0].beginTime;//上班时间
                    let endTime = res.data[0].endTime; // 下班时间
                    console.log(beginTime);
                    const [workStartHour, workStartMinute] = beginTime.split(':').map(Number);
                    const [workEndHour, workEndMinute] = endTime.split(':').map(Number);


                    // const workStartHour = 8;    // 上班小时 8
                    // const workStartMinute = 30; // 上班分钟 30
                    // const workEndHour = 18;     // 下班小时 18
                    // const workEndMinute = 0;    // 下班分钟 0
                    const lunchStartHour = 12;  // 午休开始小时 12
                    const lunchEndHour = 13;    // 午休结束小时 13
                    const lunchEndMinute = 30;  // 午休结束分钟 30
                    console.log(beginTimeDate);
                    let hours = this.calculateLeaveHours(new Date(beginTimeDate.replace(/-/g, '/')),new Date(endTimeDate.replace(/-/g, '/')), workStartHour, workStartMinute, workEndHour, workEndMinute, lunchStartHour, lunchEndHour, lunchEndMinute);
                    that.$store.state.formValue[item.id] = hours
                    that.$set(that._value, item.id, hours)

                  }
                }
              })


        }
      });


    },
    calculateLeaveHours(startTime, endTime, workStartHour, workStartMinute, workEndHour, workEndMinute, lunchStartHour, lunchEndHour, lunchEndMinute) {
      let totalLeaveHours = 0;
      let currentDate = new Date(startTime);

      // 处理跨天情况
      while (currentDate <= endTime) {
        const dayStart = new Date(currentDate);
        dayStart.setHours(0, 0, 0, 0);

        const dayEnd = new Date(currentDate);
        dayEnd.setHours(23, 59, 59, 999);

        // 当天的工作开始时间
        const workStart = new Date(dayStart);
        workStart.setHours(workStartHour, workStartMinute, 0, 0);

        // 当天的工作结束时间
        const workEnd = new Date(dayStart);
        workEnd.setHours(workEndHour, workEndMinute, 0, 0);

        // 当天的午休开始时间
        const lunchStart = new Date(dayStart);
        lunchStart.setHours(lunchStartHour, 0, 0, 0);

        // 当天的午休结束时间
        const lunchEnd = new Date(dayStart);
        lunchEnd.setHours(lunchEndHour, lunchEndMinute, 0, 0);

        // 计算当天的请假开始和结束时间
        const dayLeaveStart = new Date(Math.max(startTime, workStart));
        const dayLeaveEnd = new Date(Math.min(endTime, workEnd));

        // 如果请假时间段与工作时间有交集
        if (dayLeaveStart < dayLeaveEnd) {
          let leaveHours = (dayLeaveEnd - dayLeaveStart) / (1000 * 60 * 60);

          // 扣除午休时间
          const lunchOverlapStart = new Date(Math.max(dayLeaveStart, lunchStart));
          const lunchOverlapEnd = new Date(Math.min(dayLeaveEnd, lunchEnd));

          if (lunchOverlapStart < lunchOverlapEnd) {
            leaveHours -= (lunchOverlapEnd - lunchOverlapStart) / (1000 * 60 * 60);
          }

          totalLeaveHours += leaveHours;
        }

        // 移动到下一天
        currentDate.setDate(currentDate.getDate() + 1);
        currentDate.setHours(0, 0, 0, 0);
      }

      return totalLeaveHours;
    },
  },
};
</script>

<style scoped></style>
